export enum LineoutTarget {
    Front = 1,
    Middle = 2,
    Back = 3,
    Midfield =4,
}